export function parseSiteId() {
    const whitelisted = process.env.NEXT_PUBLIC_ENABLE_DASHBOARD;
    if (!whitelisted) return []
    return whitelisted.split(',').map((site) => site.trim());
}